module.exports = __webpack_public_path__ + "files/da816e7603c2575242ec1234c0b91a8d.png";